export const ECODE_REGEX = /^E\d{7}$/;
